<template>
  <div>
    <!-- <heads></heads> -->
    <div class="wid1200">
      <el-row class="mart30">
        <el-col :span="10">
          <div class="font18 font600 padtb5">健康的司法考试放宽那你克里斯蒂娜发</div>
          <div
            class="swiper-box"
            style="height: 400px"
          >
            <!-- swiper1 -->
            <swiper
              :options="swiperOptionTop"
              class="gallery-top"
              ref="swiperTop"
              v-if="dataList.length > 0"
            >
              <swiper-slide
                v-for="(item,index) in dataList"
                :key="index"
              >
                <img
                  class="comp-intro-banner"
                  :src="item.imgUrl"
                  alt="item.title"
                />
              </swiper-slide>
              <div
                class="swiper-button-next swiper-button-white"
                slot="button-next"
              ></div>
              <div
                class="swiper-button-prev swiper-button-white"
                slot="button-prev"
              ></div>
            </swiper>
            <!-- swiper2 Thumbs -->
            <swiper
              :options="swiperOptionThumbs"
              class="gallery-thumbs"
              ref="swiperThumbs"
            >
              <swiper-slide
                v-for="(item,index) in dataList"
                :key="index"
                class="slide-1"
              >
                <img
                  class="swiperSmallImg"
                  :src="item.imgUrl"
                  alt="item.title"
                />
              </swiper-slide>
            </swiper>
          </div>
        </el-col>
        <el-col
          :span="10"
          :offset="1"
          class="padt28"
        >
          <div>
            <span class="colred font40 font600">80</span>
            <span class="font14 col333">万</span>
            <span class="font14 col333 padl100">参考单价：15406.9元/</span>
          </div>
          <el-row class="padtb45">
            <el-col :span="6">
              <p class="font20 font600 col333 line30">1室1厅</p>
              <p class="font12 col999">底楼层/共11层</p>
            </el-col>
            <el-col :span="6">
              <p class="font20 font600 col333 line30">南北</p>
              <p class="font12 col999">平层/精装</p>
            </el-col>
            <el-col :span="6">
              <p class="font20 font600 col333 line30">56.49平米</p>
              <p class="font12 col999">2008年建/板墙结合</p>
            </el-col>
          </el-row>
          <div class="line40">
            <span class="font14 font600 col333">小名称儿</span>
            <span class="font14 col999 padl40">发大水发地方的说法</span>
          </div>
          <div class="line40">
            <span class="font14 font600 col333">小名称儿</span>
            <span class="font14 col999 padl40">发大水发地方的说法</span>
          </div>
          <div class="line40">
            <span class="font14 font600 col333">小名称儿</span>
            <span class="font14 col999 padl40">发大水发地方的说法</span>
          </div>
          <div class="callbox">
            <el-row>
              <el-col :span="4">1</el-col>
              <el-col
                :span="10"
                class="padt25"
              >
                <div class="line30">
                  <span class="font16 col333 font600">张三三</span>
                  <span class="font12 col999">房源顾问</span>
                </div>
                <div class="font14 col333">好评经纪人，熟悉本房特色</div>
              </el-col>
              <el-col :span="10">
                <p class="font20 colred font600 italic line80">400 838 7895-1142</p>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row class="mart20 font16 col333 bgf5 line30 padtb5 textcenter">
        <el-col :span="20">
          <el-col
            :span="3"
            v-for="(item1,index) in tabList"
            :key="index"
            @click.native="changeTab(index)"
          ><span :class="tabListIndex==index?'borb':''">{{item1.name}}</span></el-col>

        </el-col>
      </el-row>
      <div class="mart50">
        <el-row>
          <el-col :span="16">
            <div v-if="tabListIndex==0">
              <p class="colred font24 font600">房源基本信息</p>
              <div class="col333 font20 font600 mart30">基本信息</div>
              <el-row class="mart20">
                <el-col :span="12">
                  <ul class="msg">
                    <li>
                      房屋户型:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      建筑面积:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      套内面积:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      房屋朝向:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      装修情况:
                      <span>的发货发的</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="12">
                  <ul class="msg">
                    <li>
                      所在楼层:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      配备电梯:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      梯户比例:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      产权年限:
                      <span>的发货发的</span>
                    </li>
                  </ul>
                </el-col>
              </el-row>
              <div class="col333 font20 font600 mart30">交易信息</div>
              <el-row class="mart20">
                <el-col :span="12">
                  <ul class="msg">
                    <li>
                      挂牌时间:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      上次交易:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      房屋年限:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      抵押信息:
                      <span>的发货发的</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="12">
                  <ul class="msg">
                    <li>
                      交易权属:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      房屋用途:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      产权所属:
                      <span>的发货发的</span>
                    </li>
                    <li>
                      房本备件:
                      <span>的发货发的</span>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div>
            <div
              class="mart50"
              v-if="tabListIndex==0 || tabListIndex==1"
            >
              <el-row>
                <el-col :span="12">
                  <p class="colred font24 font600">经纪人带看反馈</p>
                </el-col>
                <el-col
                  :span="12"
                  class="textright"
                >
                  <span class="font12 col333">带看最多</span>
                  <span class="font12 col999">最新</span>
                </el-col>
              </el-row>
              <div class="dklist mart30">
                <el-row>
                  <el-col :span="3">
                    <img
                      src
                      alt
                    />
                  </el-col>
                  <el-col :span="21">
                    <el-row>
                      <el-col
                        :span="12"
                        class="font16 col333"
                      >张三三</el-col>
                      <el-col
                        :span="12"
                        class="font14 colred textright"
                      >4008808652 - 1532</el-col>
                    </el-row>
                    <div class="font14 col666 padtb5 line24 mart5">本小区位于北泉路1048号，是果壳里的城三期的房子，精装修套一，带入户花园，此房在高楼层，厨房带生活阳台，户型方正，通透户型，通风效果比较好，视野开阔，可直接拎包入住，如果对这个房子感兴趣，请联系我。</div>
                    <el-row>
                      <el-col
                        :span="12"
                        class="font12 col666"
                      >2019-12-10</el-col>
                      <el-col
                        :span="12"
                        class="font14 colred textright"
                      >
                        <el-tag type="info">有用 20</el-tag>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
              <div class="lookbtn">查看全部带看反馈</div>
            </div>

            <div
              class="mart50"
              v-if="tabListIndex==0 || tabListIndex==2"
            >
              <p class="colred font24 font600">房源图片</p>
              <el-row class="mart30">
                <el-col :span="12">
                  <div class="houseImg">
                    <img
                      src="../../../static/img/bf1.png"
                      alt
                    />
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="houseImg">
                    <img
                      src="../../../static/img/bf1.png"
                      alt
                    />
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="houseImg">
                    <img
                      src="../../../static/img/bf1.png"
                      alt
                    />
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="houseImg">
                    <img
                      src="../../../static/img/bf1.png"
                      alt
                    />
                  </div>
                </el-col>
              </el-row>
            </div>
            <div
              class="mart50"
              v-if="tabListIndex==0 || tabListIndex==3"
            >
              <p class="colred font24 font600">果壳里的城简介</p>
              <el-row class="mart30">
                <el-col :span="6">
                  <ul class="msg">
                    <li>
                      小区均价:
                      <span>14506元/</span>
                    </li>
                    <li>
                      建筑年代:
                      <span>2016年建成</span>
                    </li>
                    <li>
                      建筑类型:
                      <span>板楼/塔板结合</span>
                    </li>
                    <li>
                      楼栋总数:
                      <span>16栋</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="6">
                  <span class="colred">查看小区详情</span>
                </el-col>
                <el-col
                  :span="12"
                  class="textright"
                >
                  <img
                    src="../../../static/img/bf1.png"
                    class="sketch"
                    alt
                  />
                </el-col>
              </el-row>
            </div>
            <div
              class="mart50"
              v-if="tabListIndex==0 || tabListIndex==4"
            >
              <bdmap></bdmap>
            </div>
            <div
              class="mart50"
              v-if="tabListIndex==0 || tabListIndex==5"
            >
              <p class="colred font24 font600">为你推荐优质房源</p>
              <el-row class="mart30">
                <el-col :span="6">
                  <div class="wid95">
                    <img
                      src="../../../static/img/bf1.png"
                      alt
                      srcset
                    />
                    <div class="font14 col333">东城印象小区</div>
                    <el-row>
                      <el-col
                        :span="12"
                        class="font14 col999 line30"
                      >12-wrefsdf</el-col>
                      <el-col
                        :span="12"
                        class="textright"
                      >
                        <span class="font20 colred font600">100</span>
                        <span class="font14 colred">万</span>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="wid95">
                    <img
                      src="../../../static/img/bf1.png"
                      alt
                      srcset
                    />
                    <div class="font14 col333">东城印象小区</div>
                    <el-row>
                      <el-col
                        :span="12"
                        class="font14 col999 line30"
                      >12-wrefsdf</el-col>
                      <el-col
                        :span="12"
                        class="textright"
                      >
                        <span class="font20 colred font600">100</span>
                        <span class="font14 colred">万</span>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="wid95">
                    <img
                      src="../../../static/img/bf1.png"
                      alt
                      srcset
                    />
                    <div class="font14 col333">东城印象小区</div>
                    <el-row>
                      <el-col
                        :span="12"
                        class="font14 col999 line30"
                      >12-wrefsdf</el-col>
                      <el-col
                        :span="12"
                        class="textright"
                      >
                        <span class="font20 colred font600">100</span>
                        <span class="font14 colred">万</span>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="wid95">
                    <img
                      src="../../../static/img/bf1.png"
                      alt
                      srcset
                    />
                    <div class="font14 col333">东城印象小区</div>
                    <el-row>
                      <el-col
                        :span="12"
                        class="font14 col999 line30"
                      >12-wrefsdf</el-col>
                      <el-col
                        :span="12"
                        class="textright"
                      >
                        <span class="font20 colred font600">100</span>
                        <span class="font14 colred">万</span>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col
            :span="4"
            :offset="1"
          >
            <div class="border1 pad10">
              <p class="font18 col333 font600">果壳里的城+中高楼层...</p>
              <el-row class="borderb padtb15 mart5">
                <el-col
                  :span="6"
                  class="line30"
                >
                  <span class="font20 colred">85</span>
                  <span class="font14">万</span>
                </el-col>
                <el-col
                  :span="18"
                  class="textright font12 line40"
                >参考单价：15406.9元/</el-col>
              </el-row>
              <div class="font16 col333 line30 font600">咨询顾问</div>
              <el-row>

              </el-row>
            </div>
          </el-col>
        </el-row>

      </div>
    </div>
  </div>
</template>

<script>
import bdmap from "@/components/baiduMapView";
export default {
  name: "SecondhandRoomDetail",
  data() {
    return {
      dataList: [
        {
          imgUrl: "/static/img/bf1.png"
        },
        {
          imgUrl: "/static/img/bf1.png"
        },
        {
          imgUrl: "/static/img/bf1.png"
        },
        {
          imgUrl: "/static/img/bf1.png"
        },
        {
          imgUrl: "/static/img/bf1.png"
        },
        {
          imgUrl: "/static/img/bf1.png"
        }
      ],
      houseId: this.$route.query.id,
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        slidesPerView: 4,
        touchRatio: 0.2,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        slideToClickedSlide: true
      },
      tabList: [
        { name: "基本信息", id: "0" },
        { name: "带看反馈", id: "1" },
        { name: "房源图片", id: "2" },
        { name: "小区简介", id: "3" },
        { name: "周边配套", id: "4" },
        { name: "优房推荐", id: "5" }
      ],
      tabListIndex: 0
    };
  },
  components: {   
    bdmap
  },
  created() {
    console.log(this.houseId);
    if (this.houseId) {
      this.getinfo();
      this.getRoomIng();
    }
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper;
      const swiperThumbs = this.$refs.swiperThumbs.swiper;
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
  },
  methods: {
    getinfo() {
      this.$get("/second/house/houseInfo", {
        id: this.houseId
      })
        .then(res => {
          if (res.code == 0) {
          }
        })
        .catch(err => {});
    },
    getRoomIng() {
      this.$get("/second/house/imagePage", {
        houseId: this.houseId
      })
        .then(res => {
          if (res.code == 0) {
          }
        })
        .catch(err => {});
    },
    changeTab(id) {
      this.tabListIndex = id;
    }
  }
};
</script>

<style  lang="scss">
.swiperImg,
.swiperSmallImg {
  width: 100%;
}
.gallery-top {
  height: 80% !important;
  width: 100%;
}
.gallery-thumbs {
  height: 25% !important;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
.padl100 {
  padding-left: 100px;
}
.callbox {
  width: 90%;
  height: 5rem;
  margin-top: 1.25rem;
  background: url(/static/img/erbg.png) 100% no-repeat;
  /* border: 1px solid red; */
}
.italic {
  font-style: italic;
  height: 5rem;
  line-height: 6.25rem;
}
.padt25 {
  padding-top: 1.5625rem;
}
.msg li {
  list-style: none;
  font-size: 0.875rem;
  color: #999;
  line-height: 2.1875rem;
}
.msg li span {
  font-size: 0.875rem;
  color: #333;
  padding-left: 0.3125rem;
}
.lookbtn {
  width: 100%;
  height: 2rem;
  line-height: 2rem;
  font-size: 0.875rem;
  color: #999;
  border: 0.0625rem solid #999;
  border-radius: 0.3125rem;
  text-align: center;
  margin: 1.25rem 0rem;
}
.houseImg {
  width: 95%;
  margin: 0.625rem auto;
  height: 18.75rem;
  border-radius: 0.5rem;
  overflow: hidden;
}
.houseImg img {
  width: 100%;
  height: 100%;
}
.sketch {
  width: 10rem;
  height: 7.5rem;
}
.wid95 {
  width: 90%;
  margin: auto;
}
.wid95 img {
  width: 100%;
  height: auto;
}
.borb {
  padding-bottom: 10px;
  border-bottom: 2px solid red;
}
</style>



// WEBPACK FOOTER //
// src/pages/secondHand/SecondhandRoomDetail.vue